import { catchError, filter, switchMap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import axios from 'axios-observable';
import { PayloadEpic } from '@/store/epics/epic-types';
import { actions, asyncActions } from '@/store/slices';
import { apiEndpoints } from '@/store/constants';
import { AssetModel } from '@/models';
import { CreatePackageAssetPayload } from '@/store/slices/payload-types/asset-payload-types';

export const createPackageAssetEpic: PayloadEpic<CreatePackageAssetPayload, AssetModel> = (action$) => {
    return action$.pipe(
        filter(asyncActions.assets.createPackageAsset.match),
        switchMap(({ payload }) =>
            concat(
                of(actions.assets.setIsCreating(true)),
                createPackage(payload).pipe(
                    switchMap(({ data }) => [actions.assets.addOne(data), actions.assets.setSavingErrors(null)]),
                    catchError((error) => {
                        console.error('createPackageAssetEpic', error);

                        return of(actions.assets.setSavingErrors(error?.response?.data || {}));
                    })
                ),
                of(actions.assets.setIsCreating(false))
            )
        )
    );
};

const createPackage = (payload: CreatePackageAssetPayload) => {
    return axios.post<AssetModel>(apiEndpoints.packageAssets(), payload);
};
